module.exports = __webpack_public_path__ + "bcd1e4cdf63f4c22435c5cd4080c2ba1.pdf";